/**
 * @file 出口
 */
import state from './state';
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';
export default {
    state,
    mutations,
    getters,
    actions
};
